<template>
  <el-form @submit.native.prevent="creatBanner" :inline="true">
    <div>
      <el-card style="margin-top: 25px">
        <el-form-item label="banner标题">
          <el-input v-model="model.bannerName"></el-input>
        </el-form-item>
        <el-form-item label="banner描述">
          <el-input v-model="model.bannerDesc"></el-input>
        </el-form-item>
        <el-form-item label="banner技能">
          <el-input v-model="model.bannerSkill"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input v-model="model.bannerUrl"></el-input>
        </el-form-item>
        <el-form-item label="Banner所属分类">
          <el-select v-model="model.bannerID" placeholder="所属分类">
            <el-option
              v-for="item in bannerCate"
              :key="item.bannerID"
              :label="item.bannerType"
              :value="item.bannerID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 上传bammer图 -->
        <el-upload
          class="avatar-uploader"
          :action="$http.defaults.baseURL + '/category/img/banner'"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          list-type="picture"
          :on-success="bannerUpload"
        >
          <div>
            <img v-show="showLeImg" :src="model.bannerImg" />
          </div>
          <el-button size="small" type="primary">点击上传Banner图</el-button>
        </el-upload>
      </el-card>
    </div>

    <el-form-item style="margin-top: 25px">
      <el-button type="primary" native-type="submit">点击创建</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    id: {},
  },
  data() {
    return {
      showCoImg: true,
      showLeImg: true,
      model: {
        bannerImg: "",
      },
      banner: [],
      bannerCate: [],
    };
  },
  methods: {
    async creatBanner() {
      try {
        const bannnercreate = await this.$http.post(
          "/banner/create",
          this.model
        );
        if (bannnercreate.status === 200) {
          this.$message({
            type: "success",
            message: bannnercreate.data.msg,
          });
        }
        this.$router.push("/banner/list");
      } catch (error) {
        console.log(error);
      }
    },
    async getBannerCate() {
      try {
        const result = await this.$http.get("/bannercate/getbannercate");
        this.bannerCate = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    bannerUpload(res) {
      try {
        this.model.bannerImg = res;
        this.showLeImg = false;
      } catch (error) {
        console.log(error);
      }
    },
    handlePreview(file) {
      console.log(file);
    },

    handleRemove(uploadFile, uploadFiles) {
      console.log(uploadFile, uploadFiles);
    },
  },
  created() {
    this.getBannerCate();
  },
};
</script>

<style scoped></style>
